<div data-testid="step-9-3-invitation-preview" *transloco="let t">
  @if (!isStepPrerequisiteCompleted()) {
    <app-previous-step-incomplete-notice></app-previous-step-incomplete-notice>
  } @else {
    <p-tabs
      appTabsUnsavedReveal
      [value]="activeTabIndex()"
      data-testid="rfd-invitation-tabs"
      (valueChange)="onTabChange($event!)"
      scrollable
    >
      <p-tablist data-testid="rfd-invitation-tablist">
        <p-tab
          [value]="0"
          [appTabStatus]="mailPreviewTabStatus.signal()"
          data-testid="rfd-mail-preview-tab"
        >
          {{ 'project.steps.rfd.invitationPreview.tabMailPreview' | transloco }}
        </p-tab>
        <p-tab
          [value]="1"
          [appTabStatus]="projectDescriptionTabStatus.signal()"
          data-testid="rfd-project-description-tab"
        >
          {{ 'project.steps.rfd.invitationPreview.tabProjectDescription' | transloco }}
        </p-tab>
        <p-tab [value]="2" [appTabStatus]="summaryTabStatus.signal()" data-testid="rfd-summary-tab">
          {{ 'project.steps.rfd.invitationPreview.tabSummary' | transloco }}
        </p-tab>
      </p-tablist>
      <p-tabpanels class="mt-6" data-testid="rfd-invitation-tabpanels">
        <p-card data-testid="rfd-invitation-card">
          <p-tabpanel [value]="0" data-testid="rfd-mail-preview-tab-panel">
            @if (loadedTabs().has(0)) {
              <app-step-9-3-rfd-mail-preview
                [preloadedData]="invitationPreviewResponse()"
                (statusChange)="onMailPreviewStatusChange($event)"
              >
              </app-step-9-3-rfd-mail-preview>
            }
          </p-tabpanel>
          <p-tabpanel [value]="1" data-testid="rfd-project-description-tab-panel">
            @if (loadedTabs().has(1)) {
              <app-step-9-3-rfd-project-description
                [preloadedData]="invitationPreviewResponse()"
                (statusChange)="onProjectDescriptionStatusChange($event)"
              >
              </app-step-9-3-rfd-project-description>
            }
          </p-tabpanel>
          <p-tabpanel [value]="2" data-testid="rfd-summary-tab-panel">
            @if (loadedTabs().has(2)) {
              <app-step-9-3-rfd-agenda-summary></app-step-9-3-rfd-agenda-summary>
            }
          </p-tabpanel>
        </p-card>
      </p-tabpanels>
    </p-tabs>
  }
</div>
